import React, { Component } from "react";
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { isLoading as isRaceLoading, load as loadRace } from '../reducers/race';
import { isLoading, load as loadMeetings, get as getMeetings } from '../reducers/meetings';
import { isMeetingLoading, loadMeetingByRaceId } from '../reducers/meeting';
import { getTodaysDate } from 'utils/LocalDateTimeHelper'

import GreyhoundRacingRacePage from "../components/GreyhoundRacingRacePage";
import _ from "lodash";

import { GREYHOUND_RACE_COMPLETE_STATUSES } from 'modules/Common/consts';

const REFRESH_INTERVAL_MILLIS = 15000;

@standardAsyncConnect([
  { // this race
    dispatch: ({params: {raceId}}) => loadRace(raceId),
    preventResolve: ({state, params: {raceId}}) => isRaceLoading(state, raceId),
    state: state => ({race: state.greyhoundRacing.race || {}})
  },
  { // meetings for this date
    dispatch: ({params: {date = getTodaysDate("YYYY-MM-DD")}}) => loadMeetings(date),
    preventResolve: ({state, params: {date = getTodaysDate("YYYY-MM-DD")}}) => isLoading(state, date),
    state: state => ({meetingsByDate: getMeetings(state)})
  },
  { // meeting for this race
    dispatch: ({params: {raceId}}) => loadMeetingByRaceId(raceId),
    preventResolve: ({state, params: {raceId}}) => isMeetingLoading(state, raceId),
    state: state => ({meeting: state.greyhoundRacing.meeting || {}})
  }
])
@catchLifeCycleErrors
export default class GreyhoundRacingRacecardContainer extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    // supplied by react-router via @connect
    params: PropTypes.shape({
      date: PropTypes.string
    }),
    meeting: PropTypes.object,
    meetingsByDate: PropTypes.object,
    race: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node
  };

  raceIsFinished() {
    return GREYHOUND_RACE_COMPLETE_STATUSES.includes(this.props.race.race.race_summary.race_stage);
  }

  hasMatchingRaceIds() {
    const stateRaceId = _.get(this.props, "race.race.race_summary.race_summary_reference.id");
    const currentRaceId = _.get(this.props, "params.raceId");
    
    return `${stateRaceId}` === currentRaceId;
  }  

  componentDidMount() {
    if (!this.raceIsFinished()) {
      this.interval = setInterval(() => {
          this.props.dispatch(loadRace(this.props.race.race.race_summary.race_summary_reference.id));
          if (this.raceIsFinished() && this.interval) {
            clearInterval(this.interval);
          }
        },
        REFRESH_INTERVAL_MILLIS);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {

    // If we have an error and we dont have race data or the race ID we are 
    // viewing doesnt match whats in state then show the error
    if (this.props.race.error && (!this.props.race.race || !this.hasMatchingRaceIds())) {
      const errorPixelSrc = `/1x1.gif?type=horseracing-racecard&id=0&cb=${Date.now()}`;

      return (
        <div className="hr-racing-racecards">
          <p className="hr-racing-racecards-error-message">There has been a problem displaying this race.</p>
          <img src={errorPixelSrc} width="1" height="1" />
        </div>
      );
    }

    return (
      <GreyhoundRacingRacePage
        routes={this.props.routes}
        race={this.props.race.race}
        meetings={this.props.meetingsByDate[this.props.params.date]}
        meeting={this.props.meeting}
        children={this.props.children}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingRacePageContainer.js